import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// Self-heal returning visitors stuck on a stale, cached version of the site.
// This app does not use a service worker; unregister any legacy one (from an
// earlier version) and clear its caches so updates always show without the
// visitor having to manually clear their browser cache.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then(async (regs) => {
      const legacy = regs.filter((r) => !r.scope.includes("/nexus"));
      if (!legacy.length) return;
      await Promise.all(legacy.map((r) => r.unregister()));
      try {
        if (window.caches) {
          const keys = await caches.keys();
          await Promise.all(keys.map((k) => caches.delete(k)));
        }
      } catch (e) {
        /* noop */
      }
      window.location.reload();
    })
    .catch(() => {});
}

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
